import { withPrefix } from 'gatsby'
import variables from 'src/styles/variables'

export default {
  metadata: {
    title: 'A faster and more direct route to market. - artificial',
    desc: 'We use Machine Learning technology to modernise the insurance quoting process for pricing, analytics and risk selection.',
  },
  ArHeroHeader: {
    image: {
      alt: 'Artifical Price for insurance',
      url: withPrefix('img/ArHeroHeaderProductsPrice.png'),
    },
    title: 'Optimising pricing',
    description: 'Cutting edge risk selection and dynamic pricing technology.',
    cta: {
      label: 'Request a demo',
    },
  },
  ArTextWithImageHalvedOnTablet: {
    items: [
      {
        title: 'Modernising insurance',
        description: [
          'We believe technology should make buying and selling insurance simple.',
          ' The ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' platform uses AI technology to modernise the insurance quoting process in three key areas; pricing, analytics and risk selection.',
          { tag: 'br' },
          { tag: 'br' },
          'The extensive data analysis capabilities of our algorithms give you the power to quantify and price risks whilst simultaneously optimising profits.',
          { tag: 'br' },
          { tag: 'br' },
          'Our applications also help you bring balance and stability to your entire book of business, tackle the age-old conundrum of determining appropriate risk and return trade-off, and make pricing decisions that are more informed than ever before.',
        ],
        image: {
          alt: 'Artificial intelligence in insurance',
          url: withPrefix('img/ArTextWithImage7.png'),
        },
        scComponentMargins: {
          top: ['20px', '30px', '150px'],
          bottom: ['0', '0', '0'],
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scImageMargins: {
          right: [`-40px`, '-52.5%', '-70px'],
          bottom: ['40px', '0', '0'],
          left: ['6px', '0', '0'],
        },
        scImageWidth: [null, 690, 690],
        scGap: [0, 40, 120],
      },
      {
        title: 'Price quotes quickly and accurately',
        description: [
          'The ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' platform gives you the power to price quotes quickly and accurately. Our pricing tools take in all the factors needed to generate an informed technical premium for any risk - so your underwriters don’t have to.',
          { tag: 'br' },
          { tag: 'br' },
          'The more data captured, the more detailed the pricing. Submission data, third party data and even your current book of business and loss history: these can all be used to augment and improve the detail of your data, making pricing exquisitely accurate.',
        ],
        image: {
          alt: 'Quickly price insurance quotes with Artifical Price',
          url: withPrefix('img/ArTextWithImage8.png'),
        },
        scComponentMargins: {
          top: ['40px', '60px', '160px'],
          bottom: ['40px', '80px', '160px'],
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scImageMargins: {
          right: ['13px', '0', '0'],
          bottom: ['40px', '0', '0'],
          left: ['13px', '-47.7%', '0'],
        },
        scImageWidth: [null, 646, 560],
        scGap: [0, 40, 180],
      },
      {
        title: 'Import and enhance existing pricing models',
        description: [
          'We can also help you digitise and enhance your existing pricing models - whether they are traditional and matrix-based or complex and code-based - to take you on the journey towards full Machine Learning pricing.',
          { tag: 'br' },
          { tag: 'br' },
          'Pricing models can also be swapped in or out according to their benchmarked performance on your data or customised to suit specific customer segments and products.',
        ],
        image: {
          alt: 'digitise insurance pricing models with Artificial Price',
          url: withPrefix('img/ArTextWithImageDark3.png'),
        },
        scColors: [variables.colors.black, variables.colors.white],
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scComponentPaddings: {
          top: ['40px', '80px', '160px'],
          bottom: ['0', '0', '0'],
        },
        scImageMargins: {
          right: ['13px', '-35%', '3.952%'],
          bottom: ['40px', '0', '0'],
          left: ['13px', '0', '0'],
        },
        scImageWidth: [null, 560, 560],
        scGap: [0, 39, 131],
      },
      {
        title: 'Portfolio management made frictionless',
        description: [
          'Embrace the power of data to forecast future risks, improve customer conversion rates and observe correlations between risk variables.',
          { tag: 'br' },
          { tag: 'br' },
          'Tracking historical pricing patterns and identifying cross-sell and up-sell opportunities is now effortless thanks to our straightforward data visualisations, all displayed on a beautifully-designed dashboard interface.',
        ],
        image: {
          alt: 'Data visualisation for insurance',
          url: withPrefix('img/ArTextWithImageDark4.png'),
        },
        scColors: [variables.colors.black, variables.colors.white],
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scComponentPaddings: {
          top: ['40px', '80px', '160px'],
          bottom: ['40px', '80px', '160px'],
        },
        scImageMargins: {
          right: ['13px', '0', '0'],
          bottom: ['40px', '0', '0'],
          left: ['13px', '-42.9%', '0'],
        },
        scImageWidth: [null, 560, 560],
        scGap: [0, 94, 180],
      },
    ],
  },
}
